export const isJSON = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export function storeSet(key: string, value: unknown) {
  const currVal = typeof value === 'string' ? value : JSON.stringify(value);
  window.localStorage.setItem(key, currVal);
}

export function storeGet(key: string) {
  const currVal = window.localStorage.getItem(key) ?? '';

  if (isJSON(currVal)) {
    return JSON.parse(currVal);
  }
  return currVal;
}

export function storeRemove(key: string) {
  window.localStorage.removeItem(key);
}

export function storeClear() {
  window.localStorage.clear();
}
